export const baseURL = "https://teenpatti.project338.site/";
export const adminBaseURL = "https://admin.project338.site/";
export const key = "5TIvw5cpc0";
